export async function initCourseDates(courseDates) {
    const contentSelector = '[data-course-date-content]',
        toggleSelector = '[data-course-date-toggle]',
        contentObserver = new MutationObserver((records) => {
            records.forEach(({ target, type, attributeName }) => {
                if (type === 'attributes' && attributeName === 'hidden') {
                    if (target.hidden === false) {
                        courseDates.forEach((courseDateContainer) => {
                            const content = courseDateContainer.querySelector(contentSelector);

                            if (content !== target) {
                                content.hidden = true;
                            }
                        });
                    }

                    const toggle = document.querySelector(`${toggleSelector}[aria-controls='${target.id}']`);

                    if (toggle) {
                        toggle.setAttribute('aria-expanded', !target.hidden);
                    } else {
                        console.warn(`Toggle not found for target id: ${target.id}`);
                    }
                }
            });
        }),
        toggleObserver = new MutationObserver((records) => {
            records.forEach(({ target, type, attributeName }) => {
                if (type === 'attributes' && attributeName === 'aria-expanded') {
                    const isExpanded = target.getAttribute('aria-expanded'),
                        label = isExpanded === 'true' ? target.dataset.labelExpanded : target.dataset.labelCollapsed,
                        labelElement = target.querySelector('.label');

                    target.title = label;
                    if (labelElement) {
                        labelElement.textContent = label;
                    }
                }
            });
        });

    courseDates.forEach((courseDateContainer) => {
        const content = courseDateContainer.querySelector(contentSelector),
            toggle = courseDateContainer.querySelector(toggleSelector);

        if (content) {
            if (!content.id) {
                content.id = `course-date-content-${Math.random().toString(36).substr(2, 9)}`;
            }

            contentObserver.observe(content, {
                attributes: true,
            });
        }

        if (toggle && content) {
            toggle.setAttribute('aria-controls', content.id);

            toggle.addEventListener(
                'click',
                (event) => {
                    const toggle = event.target.closest(toggleSelector);

                    if (toggle) {
                        const contentId = toggle.getAttribute('aria-controls'),
                            content = contentId ? document.getElementById(contentId) : null;

                        if (content) {
                            content.hidden = !content.hidden;
                        }
                    }
                },
                { passive: true },
            );

            toggleObserver.observe(toggle, { attributes: true });
        }
    });
}
